var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "right-panel" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        {
          staticClass: "card-header",
          on: {
            click: function($event) {
              _vm.ritorno = !_vm.ritorno
            }
          }
        },
        [
          _c("h3", { staticClass: "mb-2" }, [_vm._v(_vm._s(_vm.title))]),
          _vm._v(" "),
          _vm._t("header")
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [_vm._t("default")], 2),
      _vm._v(" "),
      _vm.$slots.footer
        ? _c("div", { staticClass: "card-footer" }, [_vm._t("footer")], 2)
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-459632e8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-459632e8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/templates/RightPanel.vue
// module id = null
// module chunks = 